import { PlanType } from "../const/planConst";

export class BillingHelper {
  static getNextPlan = (plan: PlanType) => {
    if (plan == "basic-yearly") return "pro-yearly";
    if (plan == "pro-yearly") return "pro-plus-yearly";
    if (plan == "basic") return "pro";
    if (plan == "pro") return "pro-plus";

    return null;
  };

  static getPlanInterval = (plan: PlanType | string | null) => {
    if (!plan) return null;
    if (plan === "metered-api") return null;
    return plan.endsWith("-yearly") ? "yearly" : "monthly";
  };

  /**
   * Whether a Stripe subscription is set to end. Stripe records this either
   * as cancel_at_period_end (klap's cancel action, Churnkey) or as a
   * cancel_at date alone, which the customer portal sets on subscriptions in
   * flexible billing mode (every Checkout subscription since Sep 24 2026).
   */
  static isCancelScheduled = (subscription: {
    cancel_at_period_end?: boolean | null;
    cancel_at?: number | null;
  }) =>
    Boolean(subscription.cancel_at_period_end) ||
    subscription.cancel_at != null;
}
